import AsyncState, { createAsyncStateReducer } from "react-async-stateful";
import * as ReduxUtils from "../../lib/util/ReduxUtils";

import * as SupportActions from "./Support.action";
import { LogEntry } from "./sub-components/SupportPageStatus/SupportPageStatus";
import { Fleet } from "../../lib/types/Fleet";
import { User } from "../../lib/types/UserTypes";
import { Journey } from "../../lib/types/JourneyTypes";
import { Insight } from "../../lib/types/InsightTypes";
import { Group } from "../../lib/types/Group";
import { DataPage } from "../../Api";

const initialState = {
	logs: AsyncState.create<(DataPage<LogEntry> & { index: number }) | null>(
		null,
	),
	fleets: AsyncState.create<Fleet[]>([]),
	fleetUsers: AsyncState.create<User[]>([]),
	fleetJourneys: AsyncState.create<Journey[]>([]),
	fleetVehicles: AsyncState.create<any>({}),
	updateJourney: AsyncState.create<void>(),
	fleetInsights: AsyncState.create<Insight[]>([]),
	comps: AsyncState.create<any[]>([]),
	compEntries: AsyncState.create<any[]>([]),
	groups: AsyncState.create<Group[]>([]),
};

export type SupportReducerState = typeof initialState;

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<SupportReducerState>({
		logs: SupportActions.getLogs.type,
		fleets: SupportActions.getFleets.type,
		comps: SupportActions.getComps.type,
		compEntries: SupportActions.getCompEntries.type,
		fleetUsers: SupportActions.getFleetUsers.type,
		fleetJourneys: SupportActions.getFleetJourneys.type,
		fleetVehicles: SupportActions.getFleetVehicles.type,
		updateJourney: SupportActions.updateJourney.type,
		fleetInsights: SupportActions.getFleetInsights.type,
	}),

	ReduxUtils.createReducerMap({
		[SupportActions.updateFleet.type]: (state, action) => {
			let { fleets } = state;
			const updatedFleet = action.payload;
			if (fleets.resolved) {
				const current = fleets.value?.find((f) => f.id === updatedFleet.id);
				if (current) {
					fleets = AsyncState.resolve(
						fleets,
						fleets.value
							? fleets.value.map((f) => {
									if (f.id === updatedFleet.id) {
										return updatedFleet;
									}
									return f;
							  })
							: [],
					);
				} else {
					fleets = AsyncState.resolve(fleets, [...fleets.value!, updatedFleet]);
				}
			}

			return {
				...state,
				fleets: fleets,
			};
		},

		[SupportActions.addOrUpdateInsight.type]: (state, action) => ({
			...state,
			fleetInsights: {
				...state.fleetInsights,
				value: [...action.payload],
			},
		}),

		[SupportActions.updateInsights.type]: (state, action) => ({
			...state,
			fleetInsights: {
				...state.fleetInsights,
				value: [...action.payload],
			},
		}),

		[SupportActions.changeJourney.type]: (state, action) => {
			const newValue = state.fleetJourneys.value;
			if (newValue) {
				const index = newValue.findIndex(
					(journey) => journey.key === action.payload.key,
				);
				if (index >= 0) {
					newValue[index] = action.payload;
				}
			}

			return {
				...state,
				fleetJourneys: {
					...state.fleetJourneys,
					value: newValue,
				},
			};
		},

		[SupportActions.deleteInsights.type]: (state, action) => {
			const ids = action.payload;
			const insights = state.fleetInsights.value || [];
			ids.forEach((id: string) => {
				insights.splice(
					insights.findIndex((i) => i.id === id),
					1,
				);
			});

			return {
				...state,
				fleetInsights: {
					...state.fleetInsights,
					value: [...insights],
				},
			};
		},

		[SupportActions.deleteInsight.type]: (state, action) => {
			const insights = state.fleetInsights.value || [];
			insights.splice(
				insights.findIndex((i) => i.id === action.payload),
				1,
			);
			return {
				...state,
				fleetInsights: {
					...state.fleetInsights,
					value: [...insights],
				},
			};
		},
	}),
]);
